module.exports = __webpack_public_path__ + "static/media/ImageDoc.63d09093.png";